import React, { useEffect } from 'react';
import { Contest } from '../../../global';
import styles from './StatusBar.module.scss';
import { computeContestPhase, phaseProgress } from '../../../helpers/contestUtilities';

interface IStatusBar {
  contest: Contest;
}

const StatusBar: React.FC<IStatusBar> = ({ contest }) => {
  const [background, setBackground] = React.useState<string>('');
  const [progress, setProgress] = React.useState<number>(100);

  useEffect(() => {
    const phase = computeContestPhase(contest);
    setProgress(phaseProgress(contest));

    switch (phase) {
      case 'upload-phase':
        setBackground(styles.ongoing);
        break;
      case 'community-vote':
        setBackground(styles.client_vote);
        break;
      case 'client-vote':
        setBackground(styles.client_vote);
        break;
      case 'closed':
        setBackground(styles.closed);
        break;
      default:
        setBackground(styles.standby);
        break;
    }
  }, [contest]);

  return <div className={`${styles.statusBar} ${background}`}>{<div className={`${styles.progressBar}`} style={{ width: progress + '%' }}></div>}</div>;
};

export default StatusBar;
